import { getManualCredentialVerificationExpirationStorageFilters, } from '../../../../backend/features/credentialing-verification/shared';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router';
const searchParamNameShowExpiringOnly = 'showExpiringOnly';
export function useManualCredentialVerificationExpiringOnlyFilter() {
    const { state } = useLocation();
    const [searchParams, setSearchParams] = useSearchParams();
    const isExpiringOnlyFilterChecked = searchParams.get('showExpiringOnly') === 'true';
    const { credentialVerificationExpirationPeriod } = useSelector(getSettings);
    const { expiringManualCredentialVerificationFilters } = React.useMemo(() => getManualCredentialVerificationExpirationStorageFilters(credentialVerificationExpirationPeriod, {
        treatExpiredAsExpiring: true,
    }), [credentialVerificationExpirationPeriod]);
    const canEnableExpiringOnlyFilter = Boolean(expiringManualCredentialVerificationFilters);
    const expiringOnlyFilter = isExpiringOnlyFilterChecked ? expiringManualCredentialVerificationFilters : undefined;
    const handleShowExpiringOnlyFilterChange = React.useCallback((_event, checked) => {
        if (!canEnableExpiringOnlyFilter) {
            return;
        }
        const newSearchParams = new URLSearchParams(searchParams);
        if (checked) {
            newSearchParams.set(searchParamNameShowExpiringOnly, 'true');
        }
        else {
            newSearchParams.delete(searchParamNameShowExpiringOnly);
        }
        setSearchParams(newSearchParams, { replace: true, state });
    }, [canEnableExpiringOnlyFilter, searchParams, setSearchParams, state]);
    return {
        canEnableExpiringOnlyFilter,
        expiringOnlyFilter,
        isExpiringOnlyFilterChecked,
        handleShowExpiringOnlyFilterChange,
    };
}
